// ✅ timing.js
// src/utils/timing.js
import { STORAGE_KEYS } from '../config';
import { safeGetRaw, safeSetRaw } from './storage';

export function initStartTime() {
    const existing = safeGetRaw(STORAGE_KEYS.START_TIME);
  
    // 判斷不是 timestamp，就重新寫入
    if (!existing || isNaN(parseInt(existing, 10)) || existing.includes('GMT')) {
      const now = Date.now();
      safeSetRaw(STORAGE_KEYS.START_TIME, now);
      console.log('[timing] ✅ 設置正確 startTime:', now);
    } else {
      console.log('[timing] ✅ 已存在有效 startTime:', existing);
    }
  }
  
export function computeAndSaveTimeTaken() {
  const raw = safeGetRaw(STORAGE_KEYS.START_TIME);
  const start = parseInt(raw, 10);
  let taken = 300;
  if (!isNaN(start)) {
    taken = Math.floor((Date.now() - start) / 1000);
  }
  safeSetRaw(STORAGE_KEYS.TIME_TAKEN, taken);
  console.log('[timing] 🕒 儲存 timeTaken:', taken);
  return taken;
}

export function getTimeTakenSafe() {
  const rawTaken = parseInt(safeGetRaw(STORAGE_KEYS.TIME_TAKEN), 10);
  if (!isNaN(rawTaken) && rawTaken > 0) return rawTaken;

  const rawStart = parseInt(safeGetRaw(STORAGE_KEYS.START_TIME), 10);
  if (!isNaN(rawStart)) {
    const fallback = Math.floor((Date.now() - rawStart) / 1000);
    console.warn('[timing] ⏱ fallback 計算 timeTaken:', fallback);
    return fallback;
  }

  console.warn('[timing] ❌ fallback 到預設 300 秒');
  return 300;
}
